export default function CurrentDate(props) {
  if (props.timezone) {
    const currentDate = new Intl.DateTimeFormat("en-GB", {
      timeZone: props.timezone,
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(props.date);

    return currentDate;
  } else {
    let days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let day = days[props.date.getDay()];
    let hour = props.date.getHours();
    if (hour < 10) {
      hour = `0${hour}`;
    }
    let minutes = props.date.getMinutes();
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    return `${day} ${hour}:${minutes}`;
  }
}
